import { LoginInfoProvider } from './../../ev-dal/login-info.provider';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonService } from 'app/services/common.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { NotificationService } from './../../services/notification.service';
import {
  Component,
  EventEmitter,
  OnInit,
  ViewChild,
  AfterViewChecked,
  ElementRef,
  OnDestroy,
  Renderer2
} from '@angular/core';

import { ConfirmModalService } from '../shared/confirm-modal/confirm-modal.service';


@Component({
  selector: 'app-heat-map-brick-modal',
  templateUrl: './heat-map-brick-modal.component.html',
  styleUrls: ['./heat-map-brick-modal.component.scss']
})
export class HeatMapBrickModalComponent implements OnInit, OnDestroy, AfterViewChecked {
  minimize: Function;
  hide: Function;
  brick: any;
  category: any;
  brickId: number;
  brickDetailTitle: string;
  brickDetailData: any[];
  brickAllData: any;
  isVideosExist = false;
  brickReadStatus: boolean;
  heatMapId: number;
  studentUserId: any;
  studentPartnerId: any;
  YT: any;
  _saveBrickContent = new EventEmitter();
  _editBrickContent = new EventEmitter();
  role: string;
  brickDeleteModalFlag = false;
  hasVerticalScrollbar = false;
  requiredWatchDuration: number;
  requiredWatchPercentage = 0.75;
  showButtons: boolean;
  scrolledToBottom = false;
  destroyScrollListener: Function;
  brickShow: boolean;
  brickText: boolean;
  isbrickAutocomplete: boolean;
  scrollAPi = true;
  isCoach: boolean;
  brickLink: string;

  @ViewChild('videos') videos;
  @ViewChild('modalScreen') el: ElementRef;

  constructor(
    public element: ElementRef,
    private renderer: Renderer2,
    private notificationService: NotificationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _commonAuthService: CommonAuthenticationService,
    private _commonService: CommonService,
    private _commonDataSharedService: CommonDataSharedService,
    private confirmModalService: ConfirmModalService,
    private loginInfoProvider: LoginInfoProvider
  ) {
    this.role = this._commonAuthService.getRoleName().toLowerCase();
    this.isCoach = this.loginInfoProvider.module.toLowerCase() === 'coach';
  }

  onScroll() {
    if (!this.isVideosExist && this.isbrickAutocomplete && !this.brickReadStatus) {
      const element = this.el.nativeElement;
      const scroll = ((element.offsetHeight + element.scrollTop) / element.scrollHeight) * 100;
      if (Math.floor(scroll) >= 75 && this.scrollAPi) {
        this.scrollAPi = false;
        this.scrolledToBottom = true;
        this.autoCompleteBrick();
      }
    }

  }
  ngAfterViewChecked() {
    setTimeout(() => {
      this.hasVerticalScrollbar = this.el.nativeElement.scrollHeight > this.el.nativeElement.clientHeight;
    });
  }


  ngOnInit() {
    this.isbrickAutocomplete = this.brickAllData.items ? this.brickAllData.items['0'].autoComplete : false;
    this.brickReadStatus = this.brick ? this.brick.done : this.brickReadStatus;
    if (this.role.toLowerCase() !== 'parent') {
      this.heatMapId = this.brick ? this.brick.heatMapID : this.brickAllData.heatMapID;
    }
    this.showButtons = this.brick ? this.brick.assignToHeatMap === true : true;
    this.brickDeleteModalFlag = false;
    this.brickText = this.brickDetailData[0] ? this.brickDetailData[0].type === 'text' || this.brickDetailData[0].type === 'video' : false;
    if (this.brickDetailData && this.brickDetailData.length && this.brickText) {
      this.isVideosExist = !!this.brickDetailData.filter(c => c.type === 'video').length;
      this.brickDetailData
        .filter(c => c.type === 'video' && c.content.indexOf('youtube') > -1)
        .forEach((v: any) => {
          v.isYoutube = true;
        });
      const tag = document.createElement('script');
      tag.src = '//www.youtube.com/player_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      setTimeout(() => {
        const iframeInstance = this.videos.nativeElement.querySelectorAll('iframe');
        const videoInstance = this.videos.nativeElement.querySelectorAll('video');
        const player = this._commonService.youTubeApi(iframeInstance, videoInstance, 'heatMap', {
          brickId: this.brickId,
          contentId: this.brickAllData.items && this.brickAllData.items[0].contentId,
          status: this.brickReadStatus,
          studentUserId: this.studentUserId,
          isAutocomplete: this.isbrickAutocomplete
        });
      }, 1000);
    }

    this.destroyScrollListener = this.renderer.listen(this.el.nativeElement, 'scroll', () => {
      this.onScroll();
    });
  }

  autoCompleteBrick() {
    if (this.brickAllData && this.brickAllData.items && this.role.toLowerCase() === 'student') {
      const inputJson = {
        userId: this.studentUserId.toString(),
        contentId: this.brickAllData.items[0].contentId,
        partnerId: this.brickAllData.partnerId,
        BrickId: this.brickId,
        Completed: 1
      };
      this._commonRequestResponseService.postWithStaticHeaderData('admin/content/autocomplete', inputJson)
        .subscribe(
          () => {
            this._commonDataSharedService.autoBrick.next();
            // ???
          },
          () => {
            this.notificationService.show('error', 'Error while calling service');
          });
    }
  }
  onbodyClick() {
    if (this.brickLink && this.brickLink === 'careerAssessment') {
      let inputJson: any;
      if (this.role.toLowerCase() === 'student') {
        inputJson = {

        }
      }
      if (this.role.toLowerCase().includes('coach')) {
        inputJson = {
          studentuserid: this.studentUserId,
          partnerId: this.studentPartnerId
        }
      }

      this._commonRequestResponseService.postWithHeader('shared/youscience', inputJson)
        .subscribe(
          (careereAssessmentJson: any) => {
            window.open(careereAssessmentJson['url']);
          },
          () => {
            this.notificationService.show('error', 'Error while fetching career assessment data');
          });
    }


  }
  saveBrickContent(status: boolean, hide = true) {
    const selectedType = {
      brickId: this.brickId,
      heatMapID: this.heatMapId,
      status: status,
      studentUserId: this.studentUserId
    };
    this._commonRequestResponseService.postWithHeader('student/update/heatmapMyPlan', selectedType)
      .subscribe(() => {
        if (hide) {
          this.hide();
        }
        this.notificationService.show('success', this.brickReadStatus ? 'Content Not Completed' : 'Content Completed successfully');
        this._saveBrickContent.emit();
        this.brickReadStatus = true;
        this._commonDataSharedService.autoBrick.next();
        this._commonDataSharedService.heatMapOverviewUpdate.next();

      },
        () => {
          this.notificationService.show('error', 'Error while fetching brick data');
        }
      );
  }
  hideClick() {
    this.hide();
    this._commonDataSharedService.reRenderMyPlan.next(true);
    if (!this.isVideosExist && this.isbrickAutocomplete && !this.brickReadStatus) {
      this.autoCompleteBrick();
    }

  }

  remove() {
    this.confirmModalService.open({
      ok: () => {
        this.deleteBrick()
      },
      text: 'Are you sure you want to delete the brick?'
    });
  }

  deleteBrick() {
    const deleteBrickJson = {
      heatMapID: this.brick.heatMapID,
      studentUserId: this.studentUserId
    };
    this._commonRequestResponseService.post('coach/unassign/brick', deleteBrickJson)
      .subscribe(
        () => {
          this.notificationService.show('success', 'Bricks data deleted successfully');
          this._saveBrickContent.emit();
          this.hide();
          this._commonDataSharedService.heatMapOverviewUpdate.next();
        },
        () => {
          this.notificationService.show('error', 'Error while deleting brick data');
        });
  }

  editBrickData() {
    this._editBrickContent.emit({ category: this.category, brick: this.brick });
  }

  ngOnDestroy() {
    this.destroyScrollListener();
  }

}
